import { IconButton, Stack } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { COLORS } from 'app-constants'

/*
  This component is intended for displaying a full-screen overlay on mobile devices.
  It renders whatever children is being passed in.
*/
const MobileOverlay = ({
  closeButtonColor,
  children,
  onClose,
}: {
  closeButtonColor?: string
  children: any
  onClose?: () => void
}) => {
  return (
    <Stack
      position="fixed"
      style={{
        backgroundColor: COLORS.PURE_WHITE,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: '100%',
        width: '100%',
        zIndex: 2,
        paddingTop: '16px',
        paddingLeft: '16px',
        paddingRight: '16px',
        overflowY: 'scroll',
        paddingBottom: '80px',
      }}>
      {closeButtonColor && (
        <IconButton
          onClick={onClose}
          style={{
            paddingBottom: '16px',
            alignSelf: 'flex-start',
            paddingLeft: '16px',
          }}>
          <CloseIcon
            style={{
              fill: closeButtonColor,
            }}
          />
        </IconButton>
      )}
      {children}
    </Stack>
  )
}

export default MobileOverlay
